import { updates, mediaItems } from '@/mocks/home';

export function UpdatesSection() {
  return (
    <section id="updates" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">最新快讯</h2>
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">实时更新</span>
        </div>

        <div className="relative pl-6 md:pl-8">
          <div className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-0.5 bg-primary-200"></div>

          <div className="flex flex-col gap-6 md:gap-8">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-6 md:pl-8">
                <div className="absolute left-[-23px] md:left-[-27px] top-1.5 w-3 h-3 md:w-3.5 md:h-3.5 rounded-full bg-primary-500 border-2 border-background-50 ring-2 ring-primary-200"></div>

                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs font-mono text-primary-600 bg-primary-50 px-2 py-0.5 rounded">{item.date}</span>
                  <span className="text-xs font-medium text-accent-600 bg-accent-50 px-2 py-0.5 rounded">{item.tag}</span>
                </div>

                <h3 className="text-sm md:text-base font-semibold text-foreground-900 font-heading mb-1.5">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.summary}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  return (
    <section id="media" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">黑料视频</h2>
          <span className="text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full font-medium">高清播放</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div key={i} className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-colors cursor-pointer">
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors"></div>
                <div className="absolute top-2 left-2">
                  <span className="text-[10px] md:text-xs font-medium bg-primary-500 text-white px-2 py-0.5 rounded">{item.tag}</span>
                </div>
                <div className="absolute bottom-2 right-2">
                  <span className="text-[10px] md:text-xs font-medium bg-black/60 text-white px-2 py-0.5 rounded">{item.duration}</span>
                </div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-full bg-primary-500/80 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                    <i className="ri-play-fill text-white text-lg md:text-xl ml-0.5"></i>
                  </div>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm font-medium text-foreground-900 line-clamp-2 leading-snug mb-2">{item.title}</h3>
                <span className="text-xs text-foreground-500">{item.views} 次播放</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">联系我们</h2>
        </div>

        <div className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="flex flex-col lg:flex-row items-start gap-8 md:gap-12">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-3">投稿与合作</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                17黑料网欢迎广大网友提供线索和投稿。如果您掌握第一手黑料信息，或希望与我们进行内容合作与推广，请通过以下方式联系我们的运营团队。我们承诺对所有投稿信息严格保密，线索一经采用将给予相应奖励。
              </p>
              <div className="flex flex-wrap gap-4 md:gap-6">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-50 text-primary-600 rounded-md">
                    <i className="ri-mail-line"></i>
                  </div>
                  <span className="text-sm text-foreground-700">tips@17heilia.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 flex items-center justify-center bg-primary-50 text-primary-600 rounded-md">
                    <i className="ri-wechat-line"></i>
                  </div>
                  <span className="text-sm text-foreground-700">17heilia_official</span>
                </div>
              </div>
            </div>
            <div className="w-full lg:w-auto">
              <div className="bg-background-50 rounded-md border border-background-200/70 p-4 md:p-6 text-center">
                <div className="text-sm text-foreground-500 mb-2">扫码关注公众号</div>
                <div className="w-32 h-32 bg-background-200 rounded-md mx-auto flex items-center justify-center">
                  <i className="ri-qr-code-line text-4xl text-foreground-400"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center gap-3 mb-8 md:mb-10">
          <div className="w-1 h-6 md:h-7 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">平台介绍</h2>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/70 p-6 md:p-10">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 md:gap-10">
            <div className="lg:col-span-3">
              <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-4">关于17黑料网</h3>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  17黑料网是国内领先的国产黑料内容聚合与在线观看平台，专注于整合17c国产一区二区黑料在线观看资源。
                  我们汇集了来自娱乐圈、网红圈、社会热点等多个领域的海量黑料资讯，
                  为用户提供一站式的国产黑料视频在线播放和黑料吃瓜内容浏览体验。
                </p>
                <p>
                  平台成立以来，始终坚持以用户需求为导向，通过专业的内容编辑团队和多维度信息核实机制，
                  确保每一条黑料内容都经得起推敲。我们提供高清流畅的国产黑料视频播放服务，
                  支持多种设备访问，让用户随时随地畅享最新最热的黑料内容。
                </p>
                <p>
                  在内容安全方面，17黑料网严格遵守相关法律法规，所有内容均来自公开网络信息整合。
                  平台不存储任何用户上传的视频文件，所有播放资源均通过合规渠道获取，
                  致力于为广大网友提供安全、可靠的国产黑料在线观看服务。
                </p>
              </div>
            </div>
            <div className="lg:col-span-2 grid grid-cols-2 gap-4">
              {[
                { num: '15,000+', label: '黑料资源' },
                { num: '每日更新', label: '内容频率' },
                { num: '100万+', label: '活跃用户' },
                { num: '高清流畅', label: '播放体验' },
              ].map((stat, i) => (
                <div key={i} className="bg-background-100 rounded-md p-4 text-center">
                  <div className="text-xl md:text-2xl font-bold text-primary-600 font-heading">{stat.num}</div>
                  <div className="text-xs text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}